// AUTO-GENERATED by scripts/gen-build-info.mjs at build time. Do not edit by hand.
export const BUILD_INFO = {
  time: '2026-08-14T22:48:47.713Z',
  sha: 'ecb9daf8',
  dirty: true,
};
